import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["result", "button"]
  static values = { url: String, expectedIp: String, expectedCname: String }

  async check() {
    if (this.hasButtonTarget) {
      this.buttonTarget.disabled = true
      this.buttonTarget.textContent = "Checking..."
    }

    try {
      const response = await fetch(this.urlValue, {
        headers: { "Accept": "application/json" }
      })

      if (!response.ok) {
        this.showResult("Failed to check DNS", "error")
        return
      }

      const data = await response.json()
      this.renderResults(data)
    } catch {
      this.showResult("Failed to check DNS", "error")
    } finally {
      if (this.hasButtonTarget) {
        this.buttonTarget.disabled = false
        this.buttonTarget.textContent = "Check DNS"
      }
    }
  }

  renderResults(data) {
    if (!this.hasResultTarget) return

    this.resultTarget.textContent = ""

    const expectedIp = this.hasExpectedIpValue ? this.expectedIpValue : ""
    const expectedCname = this.hasExpectedCnameValue ? this.expectedCnameValue : "custom.opentil.ai"

    // A records
    if (data.a && data.a.length > 0) {
      const correct = expectedIp && data.a.includes(expectedIp)
      const status = correct ? "ok" : "info"
      const suffix = correct ? "" : " (proxied via CDN or not yet pointing — verification requires TXT only)"
      this.resultTarget.appendChild(this.buildRow(status, `A → ${data.a.join(", ")}${suffix}`))
    }

    // CNAME records
    if (data.cname && data.cname.length > 0) {
      const normalized = data.cname.map(c => c.replace(/\.$/, ""))
      const correct = normalized.includes(expectedCname)
      const status = correct ? "ok" : "info"
      const suffix = correct ? "" : " (proxied via CDN or custom setup — verification requires TXT only)"
      this.resultTarget.appendChild(this.buildRow(status, `CNAME → ${normalized.join(", ")}${suffix}`))
    }

    // No A or CNAME found
    if ((!data.a || data.a.length === 0) && (!data.cname || data.cname.length === 0)) {
      this.resultTarget.appendChild(this.buildRow("missing", "A/CNAME: not found — please add a DNS record pointing to your server"))
    }

    // TXT records
    if (data.txt && data.txt.length > 0) {
      this.resultTarget.appendChild(this.buildRow("ok", `TXT → ${data.txt.join(", ")}`))
    } else {
      this.resultTarget.appendChild(this.buildRow("missing", "TXT: not found"))
    }

    this.resultTarget.style.display = ""
  }

  showResult(message, type) {
    if (!this.hasResultTarget) return

    this.resultTarget.textContent = ""
    this.resultTarget.appendChild(this.buildRow(type, message))
    this.resultTarget.style.display = ""
  }

  buildRow(type, text) {
    const div = document.createElement("div")
    div.className = `dns-check-row dns-check-${type}`
    div.textContent = text
    return div
  }
}
